import {
  ExclamationCircleFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { EditableList } from '../../../../compnents/list/EditableList'
import { ThemeContext } from '../../../../theme/ThemeContext'
import {
  getDepartments,
  selectDepartments,
} from '../../../payment/list/paymentSlice'
import { columns } from './columns'
import {
  getDepartmentManagementList,
  getDepartmentManagementUpload,
} from './departmentManagementSlice'
import { EditDetailModal } from './editDetailModal'

export interface DepartmentManagementRef {
  refresh?: () => void
  tabKey?: any
}

interface DepartmentManagementProps {
  tabKey?: any
}
const RealDepartmentManagements = (
  { tabKey }: DepartmentManagementProps,
  ref: React.Ref<DepartmentManagementRef>
): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const departments = useSelector(selectDepartments)

  const theme = useContext(ThemeContext)

  const [form] = Form.useForm()

  const [pageLoading, setPageLoading] = useState(false) //表格 loading

  const [isEditRemarkVisible, setIsEditRemarkVisible] = useState(false)

  const [id, setId] = useState<string>()

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [page, setPage] = useState({ items: [], total: 0 })

  useEffect(() => {
    dispatch(getDepartments())
  }, [dispatch])


  const getPage = () => {
    setPageLoading(true)
    dispatch(
      getDepartmentManagementList({
        ...params,
        current: params.current,
        size: params.size,
        status: 1,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res.records,
          total: res.total,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (tabKey == 1) {
      getPage()
    }
  }, [params, tabKey])

  return (
    <Col
      style={{
        height: 'calc(100% - 30px)',
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Col
        style={{
          flex: 1,
          backgroundColor: theme.pn,
          borderRadius: 10,
          padding: '0px 15px 0 15px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Form
          form={form}
          autoComplete='off'
          onFinish={(values) => {
            setParams({ ...params, ...values, current: 1 })
          }}
        >
          <Row
            align='middle'
            justify='space-between'
            style={{ marginTop: 10, marginBottom: 20 }}
          >
            <Space>
              {/* <Form.Item noStyle name='name'>
                <Select
                  style={{ width: '10rem' }}
                  placeholder='科室'
                  allowClear
                  onChange={form.submit}
                >
                  {departments.map((d) => (
                    <Select.Option key={d.id} value={d.id}>
                      {d.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item> */}
              <Form.Item name='showFlg' noStyle>
                <Select
                  placeholder='状态'
                  onChange={form.submit}
                  allowClear
                  style={{ width: 140 }}
                >
                  <Select.Option value={0}>展示</Select.Option>
                  <Select.Option value={1}>不展示</Select.Option>
                </Select>
              </Form.Item>
              <Button type='primary' onClick={form.submit}>
                查询
              </Button>
            </Space>
          </Row>
        </Form>
        <EditableList
          page={{
            items: page.items,
            current: params.current,
            size: params.size,
            total: page.total,
          }}
          loading={pageLoading}
          columns={columns((action: any, v: any, e: any) => {
            switch (action) {
              case 'edit':
                setIsEditRemarkVisible(true)
                setId(v.id)
                break
              case 'stateEdit':
                dispatch(
                  getDepartmentManagementUpload({
                    departmentId: v.id,
                  })
                )
                  .then(unwrapResult)
                  .then((v) => {
                    notification.success({
                      message: '操作成功',
                      duration: 3,
                    })
                    getPage()
                  })

                break
            }
          }, params.size * (params.current - 1))}
          onChangePage={(current, size) => {
            setParams({ ...params, current, size: size || 10 })
          }}
        />
      </Col>
      <EditDetailModal
        id={id}
        visible={isEditRemarkVisible}
        onCancel={() => {
          setIsEditRemarkVisible(false)
          setId('')
          getPage()
        }}
        onOk={() => {
          setIsEditRemarkVisible(false)
          setId('')
          getPage()
        }}
      />
    </Col>
  )
}

export const YouYiKangDepartmentManagements = forwardRef(
  RealDepartmentManagements
)
